// @flow
import { ClientsActionTypes } from './constants';

type ClientsAction = { type: string, payload: {} | string };

// common success
export const clientsApiResponseSuccess = (actionType: string, data: any): ClientsAction => ({
    type: ClientsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const clientsApiResponseError = (actionType: string, error: string): ClientsAction => ({
    type: ClientsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getClient = (id: string): ClientsAction => ({
    type: ClientsActionTypes.GET_CLIENT,
    payload: { id },
});

export const addClient = (client:any):ClientsAction=>({
    type:ClientsActionTypes.ADD_CLIENT,
    payload:client
})
export const updateClient = (client:any):ClientsAction=>({
    type:ClientsActionTypes.UPDATE_CLIENT,
    payload:client
})
export const deleteClient = (id:string):ClientsAction=>({
    type:ClientsActionTypes.DELETE_CLIENT,
    payload:{id}
})

export const listClients = (): ClientsAction => ({
    type: ClientsActionTypes.LIST_CLIENTS,
    payload: {},
});


export const resetClients = (): ClientsAction => ({
    type: ClientsActionTypes.RESET,
    // type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

